import { useLocation, Link } from "react-router-dom";

export default function PaymentFailure() {
  const { search } = useLocation();
  const ref = new URLSearchParams(search).get("ref");

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 overflow-x-hidden">
      <div className="card max-w-lg w-full p-8 text-center">
        <h1 className="text-2xl font-semibold mb-2">Payment failed ❌</h1>
        <p className="text-gray-600 mb-2">Reference: <code>{ref || "n/a"}</code></p>
        <p className="text-gray-600">Please try again or use a different card.</p>
        <Link to="/enquiry?via=get-started" className="inline-block mt-6 text-blue-600 underline underline-offset-4">
          Back to payment
        </Link>
      </div>
    </div>
  );
}
